<template>
	<el-drawer v-model="drawerVisible" :size="drawerSize" :with-header="false" direction="rtl"
		append-to-body :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false"
		:show-close="false" class="enterprise-protect-area-drawer">
		<EnterpriseProtectAreaContent v-if="drawerVisible && file" :file="file" :model-value="modelValue"
			@confirm="onConfirm" @exit="onExit" />
	</el-drawer>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { isMobileOrTablet } from '@/utils'
import EnterpriseProtectAreaContent from './EnterpriseProtectAreaContent.vue'
import { resolveProtectAreaLayout } from './enterpriseProtectAreaLayout'

interface Props {
	file?: File | null
	modelValue?: Record<string, any[]>
}
const props = withDefaults(defineProps<Props>(), {
	file: null,
	modelValue: () => ({}),
})

const emit = defineEmits<{
	(e: 'confirm', value: Record<string, any[]>): void
}>()

const drawerVisible = ref(false)
const drawerSize = ref('70%')

function syncDrawerSize() {
	if (import.meta.server) return
	const layout = resolveProtectAreaLayout({
		viewportWidth: document.documentElement.clientWidth,
		isMobile: isMobileOrTablet(),
	})
	drawerSize.value = layout.drawerSize
}

function open() {
	if (!props.file) return
	drawerVisible.value = true
}
function onConfirm(value: Record<string, any[]>) {
	drawerVisible.value = false
	emit('confirm', value)
}
function onExit() {
	drawerVisible.value = false
}

onMounted(() => {
	syncDrawerSize()
	window.addEventListener('resize', syncDrawerSize)
})

onBeforeUnmount(() => {
	window.removeEventListener('resize', syncDrawerSize)
})

defineExpose({
	open,
})
</script>

<style lang="less">
.enterprise-protect-area-drawer .el-drawer__body {
	padding: 0 !important;
	overflow: hidden;
}
</style>
